import React, {FC} from "react"
import styled, {css} from "styled-components"
import {Row} from "react-bootstrap"

interface StyledRowProps {
  children: JSX.Element
  id: string
  isEditRowView?: boolean
}

const StyledRow = styled(({isEditRowView, ...rest}) => <Row {...rest} />)`
  ${({theme}) => css`
    border-radius: 5px;
    margin-top: ${theme.spacing.one};
    padding: ${theme.spacing.one} 0;
    transition: border-color 80ms ease-in;
    position: relative;
    border-color: ${(props: StyledRowProps) => (props.isEditRowView ? theme.colors.greys.mediumLight : "")};
    border-style: ${(props: StyledRowProps) => (props.isEditRowView ? "dashed" : "")};
    border-width: ${(props: StyledRowProps) => (props.isEditRowView ? "2px" : "")};
    cursor: ${(props: StyledRowProps) => (props.isEditRowView ? "pointer" : "inherit")};
  
    &:hover {
      border-color: ${(props: StyledRowProps) => (props.isEditRowView ? theme.colors.greys.mediumDark : "transparent")};
    }
  `}
`

const HomePageRow: FC<StyledRowProps> = (props) => <StyledRow {...props} />

export default HomePageRow
